/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=ListForm&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=ListForm&lang=js"

import "./index.vue?vue&type=style&index=0&id=62258fb4&scoped=true&lang=less"

import exportComponent from "E:\\workspace-javascript\\demo-blitzar-vjsf-ele-arco-202205\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62258fb4"]])

export default __exports__